module.exports = __webpack_public_path__ + "static/media/restaurantimg.93da4078.png";